import React, { useCallback } from 'react';
import { clearSuccessOverlay } from '@client/redux/modules/successOverlay/actions';
import { removeQueryParameters } from '@client/helpers/uri';
import { track } from '@client/helpers/index';
import { getSuccessOverlay } from '@client/redux/modules/successOverlay/selectors';
import { compose } from 'redux';
import { connect } from 'react-redux';
import OldSuccessOverlayWrapper from './v1/SuccessOverlayWrapper';
import SuccessOverlayWrapper from './v2/SuccessOverlayWrapper';
import { OVERLAYS } from './types';
import { isNewAcquireModal } from '@client/helpers/newAcquireModal';

interface SuccessMessageOverlayProps {
    successOverlay: OVERLAYS;
    clearSuccessOverlay: typeof clearSuccessOverlay;
}

const isNewVersion = isNewAcquireModal();

const SuccessMessageOverlay = ({
    successOverlay,
    clearSuccessOverlay,
}: SuccessMessageOverlayProps) => {
    const closeOverlay = useCallback(() => {
        removeQueryParameters();
        if (successOverlay === OVERLAYS.OVERLAY_DOI) {
            track('doi.screen.closeCta');
        }

        clearSuccessOverlay();
    }, [clearSuccessOverlay]);

    const SuccessOverlay = isNewVersion
        ? SuccessOverlayWrapper
        : OldSuccessOverlayWrapper;

    return (
        <SuccessOverlay
            closeOverlay={closeOverlay}
            successOverlay={successOverlay}
        />
    );
};

const mapStateToProps = (state: any) => ({
    successOverlay: getSuccessOverlay(state),
});

const mapDispatchToProps = {
    clearSuccessOverlay,
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SuccessMessageOverlay);
